import beaconDefaults from './site/medscape/defaults';
import init from './common/init';
import setContextData from './common/setcontext';
import overWrites from './common/overwrites';
import makeCall from './common/makecall';
import _fn from './common/main-fn';
import medscape from './site/medscape/medscape';

let initRan = false;

function execBeacon() { // Initialize Beacon
	document.removeEventListener('extensionsLoaded', execBeacon);
	init();
	initRan = true;
	document.dispatchEvent(new CustomEvent('beaconInitRan'));
	document.dispatchEvent(new CustomEvent('LibReady', { detail: 'beacon' }));
}

window.scanOmniVars = function(blockCall) { // Post Initialization Logic
	document.removeEventListener('userIDComplete', scanOmniVars);
	document.removeEventListener('beaconInitRan', scanOmniVars);
	_fn.rescanGlobals();
	setContextData();
	medscape();
	overWrites();
	if (typeof blockCall != 'boolean' || blockCall == false) {
		makeCall();
	}
}

if (typeof (Visitor) == 'undefined') { // If Launch extensions still pending
	document.addEventListener('extensionsLoaded', execBeacon);
} else {
	execBeacon();
}

if (typeof window.libLoadStatus == 'object' && window.libLoadStatus.complete) {
	if (initRan) {
		scanOmniVars();
	} else {
		document.addEventListener('beaconInitRan', scanOmniVars);
	}
} else if (typeof window.libLoadStatus == 'object') {
	document.addEventListener('userIDComplete', function() {
		if (initRan) {
			scanOmniVars();
		} else {
			document.addEventListener('beaconInitRan', scanOmniVars);
		}
	});
} else if (initRan) { // If no beacon deferral logic on page and beacon already initialized
	scanOmniVars();
} else { // Else wait for beacon initialization
	document.addEventListener('beaconInitRan', scanOmniVars);
}